// Partner Area feature flags in Kameleoon, with their variation keys. Everything else the edge
// assigns is ignored. See docs/abtest/ab-tests.md before adding one.
export const AB_TEST_FLAGS = {
  'partner-onboarding-recurring-welcome': ['off', 'on'],
} as const satisfies Record<string, readonly string[]>;

export type AbTestFlag = keyof typeof AB_TEST_FLAGS;
export type AbTestVariant<F extends AbTestFlag> =
  (typeof AB_TEST_FLAGS)[F][number];
export type AbTestVariants = { [F in AbTestFlag]?: AbTestVariant<F> };
